import React, { useState, useEffect } from 'react';
import Header from '../../../common/components/Header/Header';
import Sidebar from '../../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../../data/SiteConfig';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleRight } from '@fortawesome/pro-light-svg-icons';
import { getBankSlabPerformance } from '../../../common/constants/api';
import BankSlabTable from './BankSlabTable/BankSlabTable';
import ReportsTopBarFilter from '../TeamPerformance/ReportsTopBarFilter';
import moment from 'moment';
import * as _ from 'lodash';
import {
  getFiltersInfo,
  setFiltersInfo
} from '../../../common/utils/FiltersInfo';

const BankSlabPerformance = () => {
  const [changeMonth, setChangeMonth] = useState(
    getFiltersInfo()?.bankSlabMonth || undefined
  );

  const [tableData, setTableData] = useState([]);

  const [tableInfo, setTableInfo] = useState({ size: 50 });
  const [tableLoading, setTableLoading] = useState(true);
  const [firstLoading, setFirstLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);

  const [slabStatus, setSlabStatus] = useState('Login');

  const bankSlabReportFun = () => {
    setTableLoading(true);
    getBankSlabPerformance(
      slabStatus,
      changeMonth &&
        `${changeMonth?.year && changeMonth.year}-${changeMonth?.month &&
          changeMonth.month}-28`
    )
      .then(res => {
        if (res.error) throw new Error(res);
        setTableLoading(false);
        setTableData(res || []);
        setFirstLoading(false);
      })
      .catch(error => {
        setTableData([]);
        setTableLoading(false);
      });
  };
  useEffect(() => {
    bankSlabReportFun();
  }, [changeMonth, slabStatus]);

  useEffect(() => {
    let filters = {
      ...getFiltersInfo(),
      bankSlabMonth: changeMonth
    };
    setFiltersInfo(filters);
  }, [changeMonth]);

  const buttonList = [
    {
      label: 'Login',
      value: 'Login'
    },
    {
      label: 'Final Sanction',
      value: 'Sanctioned'
    }
  ];
  return (
    <React.Fragment>
      <Helmet title={`Dashboard RM | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-hidden font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0 ">
          <Sidebar />

          <div className="widhtMd max-screen flex-1  w-full ">
            <div className="flex">
              <div className="flex items-center  flex-col xl:flex-row w-full">
                <div className="w-full text-black-400 text-md ml-4 font-bold mt-4 relative">
                  <span className="mr-1 cursor-pointer">Reports</span>
                  <FontAwesomeIcon icon={faAngleDoubleRight} className="mr-1" />
                  <span className="text-green-800">Bank Slab Performance</span>
                </div>
              </div>
              <Header />
            </div>
            <div className="w-full">
              <ReportsTopBarFilter
                heading="Filter to see Bank Slab"
                cityFilter={false}
                changeMonth={changeMonth}
                setChangeMonth={setChangeMonth}
                validRange={{
                  min: {
                    year: moment().format('YYYY') - 30,
                    month: 1,
                    date: 28
                  },
                  max: {
                    year: moment().format('YYYY'),
                    month: moment().month() + 1,
                    date: 28
                  }
                }}
              />
              <div className="flex justify-end mr-3 p-3 bg-white items-center ">
                {buttonList.map((each, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => setSlabStatus(each?.value)}
                      className={`cursor-pointer  rounded border border-grey-990  px-4 py-1 font-roboto text-sm font-light ${
                        each.value === slabStatus
                          ? 'bg-orange-600 text-white'
                          : 'text-grey-995'
                      }`}
                    >
                      {each?.label}
                    </div>
                  );
                })}
              </div>
              <BankSlabTable
                tableData={tableData}
                tableInfo={tableInfo}
                tableLoading={tableLoading}
                setPage={setPage}
                setPageSize={setPageSize}
                changeMonth={changeMonth}
                firstLoading={firstLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BankSlabPerformance;
